import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { IMyOptions, IMyDate } from 'mydatepicker';
import { GoogleMapsComponent } from '../../../A2-utils/google-maps/google-maps.component';
import { TrackerService } from 'app/services/tracker.service';
import { VehiclesService } from 'app/pages/vehicles/vehicles.service';
import { AutoSchedulerService } from './../../../auto-scheduler/auto-scheduler.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss']
})
export class TrackerComponent implements OnInit, OnDestroy {

  @ViewChild(GoogleMapsComponent) map: GoogleMapsComponent;
  @ViewChild('editUnitModal') editUnitModal : T2CardComponent;

  today = new Date();
  myDatePickerOptions: IMyOptions = {
    dateFormat: 'yyyy-mm-dd',
    editableDateField: false,
    disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1 }
  };

  gridUnits: GridOptions;
  mapIsLoad = false;
  connection;
  date: IMyDate = {year: 0, month: 0, day: 0};
  iconCar = 'assets/images/marker/car_green.png';
  iconCarOff = 'assets/images/marker/car_red.png';

  showHistory = false;
  markersCar = [];
  markersCarOff = [];
  numVehicles = 0;
  vehiclesData = [];
  public mask_time = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
  timeInitial: any;
  timeEnd: any;
  editUnit: any = {};
  showInactive = false;
  private timer: any;
  filterGrid = [];

  constructor(
    private trackerService: TrackerService,
    private vehiclesService: VehiclesService,
    private autoSchedulerService: AutoSchedulerService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.gridUnits = <GridOptions>{
      getRowStyle: this.getRowStyleScheduled
    };
    this.gridUnits.columnDefs = [
      { headerName: '', checkboxSelection: true, headerCheckboxSelection: true, width: 27 },
      { headerName: 'Unit', field: 'code', width: 64 },
      { headerName: 'Phone', field: 'phone', width: 74 },
    ];
    const self = this.gridUnits;
    this.gridUnits.onGridReady = function(){
      self.api.sizeColumnsToFit();
    };
  }

  ngOnInit() {
    this.setDataNow();
    this.getVehicles();
    this.onConection(false);

    this.timer = setInterval(() => {
      this.getVehicles();
    }, 20000);
  }

  ngOnDestroy() {
    this.connection.unsubscribe();
    clearInterval(this.timer);
  }

  onMapInitialized() {
    this.mapIsLoad = true;
  }

  /**
   * gestiona el colo del texto de la grid
   * @param params
   */
  getRowStyleScheduled(params) {
    if (params.data) {
      if (params.data.active) {
        return {
          'color': 'green'
        };
      } else{
        return {
          'color': 'red'
        };
      }
    }
  }

  onConection(conection: boolean) {
    if(!conection) {
      this.markersCar = [];
      this.connection = this.trackerService.getLocations().subscribe( (locations: any) => {
        const point = { lat: locations.lat, lng: locations.lng };
        const unitArray = this.findUnitArray(locations.driver.driverid);
        if (unitArray) { // Si la unidad existe en el array que me retorna el backend entonces pinto y actualizo markers.
          const obj = this.findDriver(locations.driver.driverid);
          if(!obj) {
            const tem: any = this.map.addMarker( point, this.iconCar, locations.driver.name);
            tem.setVisible(false);
            this.markersCar.push({
              driverid: locations.driver.driverid,
              lat: locations.lat,
              lng: locations.lng,
              marker: tem
            });
            this.map.addMarkerCustomInfoWindowMultiLines(tem, [ 'Unit: ' + locations.driver.name, 'Phone: ' + unitArray.phone ]);
            this.map.centerOverMarkers();
          } else {
            this.updateLocation( locations.driver.driverid, locations.lat, locations.lng );
          }
        }
      });
    } else {
      this.connection.unsubscribe();
      this.gridUnits.api.deselectAll();
      this.map.clearMarkers();
    }
  }

  /**
   * Busca un driver en el array de markerscar y markerscaroff depende del
   * parametro inactive
   */
  findDriver(driverId: number, inactive?: boolean) {
    if (inactive) {
      return this.markersCarOff.filter((row) => {
        return row.driverid === driverId;
      })[0];
    } else {
      return this.markersCar.filter((row) => {
        return row.driverid === driverId;
      })[0];
    }
  }

  /**
   * Este metodo busca en el array de unidades que retorna el servicio y retorna una unidad.
   */
  findUnitArray(driverid: number) {
    return this.vehiclesData.filter((row) => row.driverid === driverid)[0];
  }


  updateLocation(driverId: number, lat: any, lng: any) {
    this.markersCar.forEach((row) => {
      if (row.driverid === driverId) {
        row.lat = lat;
        row.lng = lng;
        this.map.moveMarker(row.marker, {lat: lat, lng: lng});
      }
    });
  }

  setDataNow() {
    const today = new Date();
    this.date = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() };
  }

  getVehicles() {
    this.vehiclesService.getVehiclesByProviderByInactive(86, this.showInactive).subscribe(
      (resp: any) => {
        this.filterGrid = this.gridUnits.api.getSelectedNodes();
        this.gridUnits.api.setRowData(resp);
        this.numVehicles = resp.length;
        this.vehiclesData = resp;
        this.setCheckGrid();
      }
    );
  }

  /**
   * Conserva los check de la grid cuando se recarga
   */
  setCheckGrid() {
    if (this.filterGrid.length > 0) {
      this.filterGrid.forEach((row) => {
        this.gridUnits.api.forEachNode((data) => {
          if (row.data.driverid === data.data.driverid) {
            data.setSelected(true);
          }
        });
      })
    }
  }

  public updateDateofService(event) {
    if (event.formatted !== '') {
      this.gridUnits.api.deselectAll();
      this.date = event.date;
    }
  }

  onSelectedRow(event) {
    if (event.node.isSelected()) {
      if (this.showHistory && event.data.driverid && this.timeInitial && this.timeEnd) {
          const dateInitial = `${this.date.year}-${(this.date.month < 10 ? '0' : '') +
          this.date.month}-${(this.date.day < 10 ? '0' : '') +
          this.date.day} ${this.timeInitial}`;

          const dateEnd = `${this.date.year}-${(this.date.month < 10 ? '0' : '') +
          this.date.month}-${(this.date.day < 10 ? '0' : '') +
          this.date.day} ${this.timeEnd}`;

          this.trackerService.getLocationTracker(event.data.driverid, dateInitial, dateEnd).subscribe(
            (resp: any[]) => {
              if(resp.length > 0) {
                this.map.clearMarkers();
                const path = [];
                resp.forEach((row, index) => {
                  path.push({lat: row.latitude, lng: row.longitude, order: index + 1});
                });
                this.autoSchedulerService.osrmFullPath(path).subscribe(
                  (resp: any) => {
                    this.map.addPolyline( this.map.decodePolyline(resp.routes[0].geometry), 'red')
                    this.map.centerOverSomeMakers(path);
                  }
                );
              } else {
                this.sweetAlertHelper.createCustomAlert({
                  text: 'The unit has no history',
                  type: 'error'
                });
              }
            }
          );
      } else {
        if (event.data.active) {
          const driver: any = this.findDriver(event.data.driverid);
          if (driver && driver.marker) {
            driver.marker.setVisible(true);
            this.map.moveCamera(driver.lat, driver.lng, 14);
          }
        } else {
          // Mostrar la unidad que no esta activa...
          this.showCarInactive(event.data);
        }
      }
    } else {
      if (event.data.active) {
        const driver: any = this.findDriver(event.data.driverid);
        if (driver && driver.marker) {
          driver.marker.setVisible(false);
          this.map.clearPolylines();
          this.map.centerOverMarkers();
        }
      } else {
        // Si quitamos el check del row eliminamos el car del mapa si es los que no estan activos.
        this.deleteCarInactive(event.data);
      }
    }
    if(this.gridUnits.api.getSelectedRows().length === this.numVehicles) {
      this.map.centerOverMarkers();
    }
  }

  /**
   *
   * @param $event Abrimos el modal para editar el nombre de la unidad
   */
  onRowDoubleClicked($event) {
    this.editUnit.vehicleid = $event.data.vehicleid;
    this.editUnit.code = $event.data.code;
    this.editUnitModal.open();
  }

  /**
   * Servicio que actualiza el nombre de la unidad
   */
  onUpdateUnit() {
    this.trackerService.putUnitCode(this.editUnit).subscribe(
      data => {
        this.editUnitModal.close();
        this.editUnit = {};
        this.getVehicles();
      }
    )
  }

  /**
   * Cuando se busca una unidad, la localiza y se situa sobre esta.
   * @param $event
   */
  onAutoCompleteSelected($event){
    const driver: any = this.findDriver($event.driverid);
    driver.marker.setVisible(true);
    this.map.moveCamera(driver.lat, driver.lng, 14);
  }

  /**
   * muestra las unidades desactivadas en el mapa con un car de color verde.
   * siempre y cuando no esten pintadas.
   * @param data
   */
  showCarInactive(data: any) {
    if (!this.findDriver(data.driverid, true)) {
      const point = { lat: data.latitude, lng: data.longitude };
      const tem: any = this.map.addMarker( point, this.iconCarOff, data.code);
      tem.setVisible(true);
      this.markersCarOff.push({
        driverid: data.driverid, lat: data.latitude, lng: data.longitude,
        marker: tem
      });
      this.map.addMarkerCustomInfoWindowMultiLines(tem, [ data.code ]);
      this.map.centerOverMarkers();
    }
  }

  /**
   * Este metodo quita del array la unidad del array de markersoff
   * @param data
   */
  deleteCarInactive(data: any) {
    this.markersCarOff.forEach((row, index) => {
      if (row.driverid === data.driverid) {
        row.marker.setMap(null);
        this.markersCarOff.splice(index, 1);
      }
    });
  }

  /**
   * Este metodo elimina todos las unidades inactivas
   * y se usa cuando se desactiva el showInactive
   */
  deleteCarAllInactive() {
    this.markersCarOff.forEach((row, index) => {
        row.marker.setMap(null);
        this.markersCarOff.splice(index, 1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/tracker/components/tracker/tracker.component.ts